import { render, staticRenderFns } from "./extra-quickndirty-ehrenamt.vue?vue&type=template&id=683f2fcc&scoped=true&lang=pug&"
import script from "./extra-quickndirty-ehrenamt.vue?vue&type=script&lang=js&"
export * from "./extra-quickndirty-ehrenamt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f2fcc",
  null
  
)

export default component.exports